import Fuse from 'fuse.js';
export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData2() {
      let result = this.tableData2;
      if (this.searchedData2.length > 0) {
        result = this.searchedData2;
      } else {
        if (this.searchQuery2) {
          result = []
        }
      }
      return result.slice(this.from2, this.to2);
    },
    to2() {
      let highBound = this.from2 + this.pagination2.perPage;
      if (this.total2 < highBound) {
        highBound = this.total2;
      }
      return highBound;
    },
    from2() {
      return this.pagination2.perPage * (this.pagination2.currentPage - 1);
    },
    total2() {
      return this.searchedData2.length > 0
        ? this.searchedData2.length
        : this.tableData2.length;
    }
  },
  data() {
    return {
      pagination2: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50,100,200],
        total: 0
      },
      searchQuery2: '',
      searchedData2: [],
      fuseSearch2: null
    }
  },
  methods: {
    sortChange({ prop, order }) {
      if (prop) {
        this.tableData2.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.tableData2.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
    reloadSearch(){
      this.fuseSearch = new Fuse(this.tableData2, {
        keys: this.propsToSearch2,
        threshold: 0.05,
		location: 0,
		distance: 100,
		maxPatternLength: 20,
		minMatchCharLength: 1
      });
    }
  },
  mounted() {
    this.reloadSearch()
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery2(value) {
      let result = this.tableData2;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData2 = result;
    },
    tableData2(value){
      this.reloadSearch()
      let result = this.tableData2;
      if (this.searchQuery2 !== '') {
        result = this.fuseSearch.search(this.searchQuery2);
      }
      this.searchedData2 = result;
    }
  }
}
